import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';
import { SET_RATE_LIMITS_BY_USER } from './mutationTypes';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_RATE_LIMITS_BY_USER](state, rateLimits) {
    state.rateLimits = rateLimits;
  }
};